module.exports = __webpack_public_path__ + "img/idcard.d071c89a.svg";